<template>
<div>

  <CContainer :fluid="true">
        <h1 class="fw-200">Editar Solicitud</h1>
            <br>
             <CRow>
                <CCol>
                    <h2 class="fw-200">Productos</h2>
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="12" class='px-0'>
                    <CListGroup>
                        <CListGroupItem>
                            <CForm @submit.prevent="addItem" ref="item_form">
                            <CRow class="d-flex gx-2">
                                <CCol  md="4">
                                    <CInput 
                                        ref='name'
                                        :disabled='editableItem !== ""' 
                                        v-bind.sync="item_form_errors.name" 
                                        placeholder='Nombre del producto' 
                                        v-model='item_form.name' 
                                        @input='clearItemFormError("name")'
                                        label='Nombre del producto'/>

                                </CCol>
                                <CCol md="2">
                                    <CInput 
                                        ref='quantity'
                                        :disabled='editableItem !== ""'  
                                        v-bind.sync="item_form_errors.quantity"  
                                        placeholder='Cantidad' 
                                        v-model="item_form.quantity" 
                                        @input='updateSubtotal("quantity")' 
                                        label='Cantidad'/>
                                </CCol>
                                <CCol md="2">
                                    <CInput 
                                        id='price'
                                        ref='price' 
                                        :disabled='editableItem !== ""' 
                                        v-bind.sync="item_form_errors.price" 
                                        lang='es' 
                                        placeholder='Precio por unidad' 
                                        v-model="item_form.price" 
                                        @input="updateSubtotal('price')" 
                                        label='Precio por unidad'>
                                            <template #prepend-content><CIcon name='cil-dollar' /></template>
                                    </CInput>
                                </CCol>
                                <CCol  md="2">
                                    <CInput 
                                        disabled 
                                        
                                        placeholder='Subtotal' 
                                       :value='subtotalWithCommas'
                                        label='Subtotal'>
                                            <template #prepend-content><CIcon name='cil-dollar' /></template>
                                    </CInput>
                                </CCol>
                                <CCol md='2' class=''>
                                    <CButton 
                                        class='item-form-button' 
                                        color='primary' 
                                        type='submit'>
                                        Agregar Item
                                    </CButton>
                                </CCol>
                            </CRow>
                            </CForm>
                        </CListGroupItem>
                        <CListGroupItem 
                        class='sticky-top'
                        color="dark"
                        >
                            <CRow class="d-flex">
                                
                                <CCol col="3" sm="4">
                                    <span class='d-none d-sm-block'>Nombre del Producto</span>
                                    <span class='d-sm-none'>N. del Producto</span>
                                </CCol>
                                <CCol col="3" sm="3">
                                    <span class='d-none d-sm-block'>Cantidad</span>
                                    <span class='d-sm-none'>Cant.</span>
                                </CCol>
                                <CCol col="3" sm="2">
                                    <span class='d-none d-sm-block'>Precio por unidad</span>
                                    <span class='d-sm-none'>Precio unitario</span>
                                </CCol>
                                <CCol col="3" sm="2">
                                    Subtotal
                                </CCol>
                            </CRow>
                        </CListGroupItem>
                        <CListGroupItem 
                        class='item-list'
                        color="light"
                        
                        >
                            <CRow class="d-flex item overflow-hidden" v-for='(item, i) in form.description.items' :key='`item-${i}`'>
                                
                                <CCol col="3" sm="4" class='d-flex align-items-center editable-item-input '>

                                    <CInput v-if='editableItem === i'
                                        :ref='`name-${i}`' 
                                        class='flex-fill mb-auto'
                                        v-bind.sync="editable_item_form_errors.name" 
                                        placeholder='Nombre del producto' 
                                        v-model='form.description.items[i].name' 
                                        @input='clearItemFormError("name")'/>

                                    <span class='text-truncate' v-else>
                                        {{item.name}}
                                        </span>
                                    
                                </CCol>

                                <CCol col="3" sm="3" class='d-flex align-items-center editable-item-input'>
                                    <CInput v-if='editableItem === i'
                                        :ref='`quantity-${i}`' 
                                        class='flex-fill mb-auto'
                                        v-bind.sync="editable_item_form_errors.quantity"  
                                        placeholder='Cantidad' 
                                        v-model="form.description.items[i].quantity" 
                                        @input='updateEditableItemSubtotal(i)'/>
                                    <span v-else>
                                        {{item.quantity}}
                                    </span>
                                    
                                </CCol>
                                <CCol col="3" sm="2" class='d-flex align-items-center editable-item-input'>
                                      <CInput v-if='editableItem === i'
                                        :id='`price-${i}`'
                                        :ref='`price-${i}`'  
                                        class='flex-fill mb-auto'
                                        v-bind.sync="editable_item_form_errors.price" 
                                        lang='es' 
                                        placeholder='Precio por unidad' 
                                        v-model="form.description.items[i].price" 
                                        @input="updateEditableItemSubtotal(i)" >
                                            <template #prepend-content><CIcon name='cil-dollar' /></template>
                                    </CInput>
                                    <span v-else>
                                        {{form.description.items[i].price ? `$${$utils.completeWithZeros(form.description.items[i].price.toString().replace('.', ','))}` : 'N/A'}}
                                    </span>
                                    
                                </CCol>
                                <CCol col="3" sm="2" class='d-flex align-items-center editable-item-input'>
                                    <CInput v-if='editableItem === i'
                                        disabled 
                                        class='flex-fill mb-auto'
                                        :id='`subtotal-${i}`'
                                        placeholder='Subtotal' 
                                        :value="editableItemSubtotalWithCommas">
                                            <template #prepend-content><CIcon name='cil-dollar' /></template>
                                    </CInput>
                                    <span v-else>
                                          ${{$utils.completeWithZeros(form.description.items[i].subtotal.toString().replace('.', ','))}}
                                    </span>
                                   
                                </CCol>
                                <CCol col='12' sm='1' class='d-flex align-items-center mt-2 mt-sm-0' >
                                    <template v-if='editableItem === i'>
                                        <CButton size='sm' color='primary' @click="updateItem(i)"><CIcon name='cil-check-alt' size='md'/></CButton>
                                    </template>
                                    <template v-else>
                                        <CButton class='mr-1' size='sm' color='warning' @click='setEditableItem(i)'><CIcon name='cil-pencil' size='sm'/></CButton>
                                        <CButton size='sm' color='danger' @click="deleteItem(i)"><CIcon name='cil-x' size='sm'/></CButton>
                                    </template>
                                </CCol>
                            </CRow>
                        </CListGroupItem>
                      
                    </CListGroup>
                </CCol>
            </CRow>
             <br>
            <CRow>
                <CCol>
                    <h2>Datos de la solicitud</h2>
                </CCol>
                <CCol sm='12'>
                    <CListGroup>
                        <CListGroupItem>
                            <CForm  ref="order_form">
                            <CRow >
                                <CCol md='3' class='order-2 order-md-1'>
                                    <CSelect
                                        ref="priority_id"
                                        v-bind.sync="errors.priority_id" 
                                        :options='priorities' 
                                        label='Prioridad' 
                                        :value.sync='form.priority_id'
                                        @input='clearOrderFormError("priority_id")'
                                        />
                                </CCol>
                                <CCol md='3' class='order-3 order-md-2'>
                                    <CSelect 
                                        ref="department_id"
                                        v-bind.sync="errors.department_id" 
                                        :options='departments' 
                                        label='Sector' 
                                        :value.sync='form.department_id'
                                        @input='clearOrderFormErrors("department_id")'/>
                                </CCol> 
                                <CCol md='3' class='order-4 order-md-3'>
                                    <CSelect 
                                        ref="scheduled_order"
                                        v-bind.sync="errors.scheduled_order" 
                                        :options='orderTypes' 
                                        label='Tipo de solicitud'
                                        :value.sync='isScheduledOrder' 
                                        @change="setScheduledOrder($event)"
                                        @input='clearOrderFormErrors("scheduled_order")'/>
                                </CCol>
                                <CCol md='3' class='order-1 order-md-4'>
                                    <CInput disabled label='Total' :value='totalWithCommas'/>
                                </CCol>
                                
                            </CRow>
                            <CRow>
                                <CCol md='6' class='order-2 order-md-1'>
                                    <CTextarea 
                                        v-model="form.description.text" 
                                        placeholder='Mensaje (Opcional, max. 80 caracteres)' 
                                        :value.sync='form.description.text'
                                        @input='clearOrderFormErrors("description.text")'/>
                                </CCol>
                                <CCol md='3' class='order-1 order-md-2'>
                                    <CInput 
                                        ref="days"
                                        v-bind.sync="errors.days" 
                                        label='Cantidad de días' 
                                        
                                        v-model="form.scheduled_order.days" 
                                        v-if="form.scheduled_order != 0"
                                        :value.sync='form.scheduled_order.days'
                                        @input='clearOrderFormErrors("days")'/>
                                </CCol>
                                <CCol md='3' class='order-3 order-md-3 buttons-container'>
                                    <label for="" class='w-100'>Acciones</label>
                                    <CButton color='success' class='mb-2 mb-sm-0 buttons' @click="submit(getStatusForOrder)">
                                        Aprobar
                                    </CButton>
                                    <CButton color='danger' class='ml-xl-4 buttons' @click="submit(3)">
                                        Rechazar
                                    </CButton>
                                </CCol>
                            </CRow>
                             <CRow>
                                <CInput
                                    type="hidden"
                                    ref="hidden"
                                    v-bind.sync="errors.hidden"
                                    v-model="order.hidden"
                                />
                            </CRow>
                            </CForm>
                        </CListGroupItem>
                    </CListGroup>
                </CCol>
            </CRow>
   

  </CContainer>
</div>
</template>

<script>

/***
 * 
 *  TODO: Hay valores de estado de orden harcodeados acá. VER URGENTE.
 * 
 */
import axios from 'axios';
export default {
    props: {
        orderId: {
            required: true
        }
    },
    data(){
        return {
            errors: {},
            priorities: [],
            departments: [],
            editable_item_form_errors: {},
            item_form_errors: {},
            item_form: {
                quantity: '',
                price: '',
                subtotal: ''
            },
            order: {
                hidden: undefined
            },
            editableItem: '',
            older_form_data: {},
            form: {
                description: {
                    items: [],
                    text: "",
                },
                scheduled_order: 0,
                priority_id: 1,
                department_id: 1,
                total: 0
            },
            shouldSchedule: 0,
            orderTypes: [
                {value: 0, label: 'Normal'},
                {value: 1, label: 'Automática'}
            ],
            statuses: [
                {value: 2, label: "approved"},
                {value: 3, label: 'rejected'},
                {value: 4, label: 'modified'}
            ],
            fetched: false,
            scheduled_order: {}
        }
    },
    created(){
        this.getExternalData();
        this.getOrderInformation();
    },
    mounted(){
        let priceInput = document.getElementById('price');
        this.$utils.registerPriceInput([priceInput]);  
    },
    methods:{
        setScheduledOrder(event){
          
            if(typeof this.form.scheduled_order == 'object'){
                this.scheduled_order = this.form.scheduled_order
            }
            if (event.target.value == 1 && this.scheduled_order.length > 0){
                this.form.scheduled_order = this.scheduled_order;
            } else {
                this.form.scheduled_order = event.target.value
            }
            
        },
        addItem(){
            const originalPrice = this.item_form.price + ''; // evitamos pass by reference
            this.item_form.price = this.$utils.getFormattedPrice(this.item_form.price + '')

            this.item_form_errors = {};
            let form = this.item_form;
            this.$api.item_form.store(form)
                .then(res => {
               
                    this.form.description.items.push(form);
                    this.clearItemForm();
                    this.updateTotal();
                    this.$refs.name.$el.children[1].focus()

                })
                .catch(error => {
                    if(error.response){
                        this.setItemFormErrorMessages(error.response.data.errors);
                    }
                    this.item_form.price = originalPrice;   

                });
            
        },
        deleteItem(index){
            this.form.description.items.splice(index, 1);
            this.updateTotal();
        },
        updateSubtotal(label = null){
            if(label){
                this.clearItemFormError(label);
            }
            let formattedItemPrice = this.$utils.getFormattedPrice(this.item_form.price)
            let calc = (this.item_form.quantity * formattedItemPrice).toFixed(2);
            if (!isNaN(parseInt(calc))){
                this.item_form.subtotal = calc;
            } else {
                this.item_form.subtotal = 0;
            }
            
        },
        clearItemFormError(label){
            this.item_form_errors[label] = {};
        },
        clearItemForm(){
            let form = this.$refs.item_form;
            form.reset();
            this.item_form = {
                quantity: '',
                price: '',
                subtotal: ''
            };
        },
        clearOrderFormErrors(label){
            this.errors[label] = {};
        },
        clearForm(){
            let order_form = this.$refs.order_form;
            order_form.reset();
            this.updateTotal();
            this.clearItemForm();
            this.form = {
                description: {
                    items: [],
                    text: "",
                },
                scheduled_order: null,
                priority: "",
                department: "",
                total: 0
            };
        },
        getOrderInformation(){
            let me = this;

            this.$api.orders.show(me.orderId)
            .then(res => {
                let order = res.data.data[0];
                
                me.form.description = (typeof order.description == 'string') ? JSON.parse(order.description) : order.description;
                me.form.scheduled_order = order.scheduled_order ? order.scheduled_order : 0;
                me.form.priority_id = order.priority.id;
                me.form.department_id = order.department.id;
                // guardamos la data vieja para ver si cambió.
                me.setOldForm(this.form);
                
                this.updateTotal();
                this.fetched = true;
            })
            .catch(error => {
                console.log(error);
            })
        },
        setOldForm(oldForm){
            console.log('seteando oldForm', oldForm)
            // Evitamos el Pass-by-reference
            let obj = JSON.parse(JSON.stringify(oldForm));
            //obj.total = this.updateTotal();
            this.older_form_data = obj;
        },
        getExternalData(){
            let me = this;
            let request_1 = me.$api.departments.index();
            let request_2 = me.$api.priorities.index();
            axios.all([request_1, request_2])
            .then(axios.spread((response_1, response_2) => {
                me.departments = [];
                me.departments = response_1.data.data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                });

                me.priorities = [];
                me.priorities = response_2.data.data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                });
            }))
            .catch(error => {
                console.log(error);
                console.log(error.response);
            });
        },
        updateTotal(){
            let total = 0;
            this.form.description.items.forEach(item => {
                
                let formattedPrice = this.$utils.getFormattedPrice(item.subtotal.toString());
                total = parseFloat(total + formattedPrice) ;
            });
            this.form.total = total;
        },
        submit(status){
            let me = this;
            let form = this.form;

            form.status_id = status;
            this.$api.orders.update(me.orderId, form)
             .then(response => {
                this.$swal.fire({
                    titleText: "¡Excelente!",
                    text: response.message ?? "Orden editada exitosamente",
                    icon: "success"
                });
                this.$router.push('/ordenes');
            })
            .catch(error => {
               
                this.$swal.fire({
                    titleText: "Algo salió mal",
                    text: error.response.message ?? "Error al actualizar",
                    icon: "error"
                });
                if(error.response.status = 422){
                    me.setErrorMessages(error.response.data.errors);
                }
            });
        },
        setErrorMessages(errors){
            let me = this;
            for (const item in errors) {
                me.errors[item] = {
                    invalidFeedback: errors[item].reduce((acc, cur) => acc + "\n" + cur),
                    isValid: false
                };
                this.$refs[item]
            }
            me.$refs["hidden"].$emit('input',(Math.random()*1e32).toString(36), new InputEvent(""));

        },
        setItemFormErrorMessages(errors, index = null){
            let me = this;
            if(typeof index == 'number'){
                for (const item in errors) {
                    me.editable_item_form_errors[item] = {
                        invalidFeedback: errors[item].reduce((acc, cur) => acc + "\n" + cur),
                        isValid: false
                    };
                    this.$refs[item]
                }
            } else {
                for (const item in errors) {
                    me.item_form_errors[item] = {
                        invalidFeedback: errors[item].reduce((acc, cur) => acc + "\n" + cur),
                        isValid: false
                    };
                    this.$refs[item]
                }
            }
            me.$refs["hidden"].$emit('input',(Math.random()*1e32).toString(36), new InputEvent(""));
        },

 
        
        setEditableItem(index){
            this.editableItem = index;
            if(typeof index === 'number'){
                setTimeout(() => {
                    let priceInput = document.getElementById(`price-${index}`);
                    let subtotalInput = document.getElementById(`subtotal-${index}`)

                    this.$utils.registerPriceInput([priceInput, subtotalInput]);
                    // Comprobamos que no sea null
                    let price = this.form.description.items[index].price
                    if(price !== null){
                        price = price.toString().replace('.',',');
                        this.form.description.items[index].price = this.$utils.completeWithZeros(price);
                    }
                    
                }, 100)
            }
        },
        updateEditableItemSubtotal(index){
                let formattedEditablePrice = this.$utils.getFormattedPrice(this.form.description.items[index].price + '');
                let calc = (this.form.description.items[index].quantity * formattedEditablePrice).toFixed(2).toString().replace('.',',');
                if(!isNaN(parseInt(calc))){
                    this.form.description.items[index].subtotal = calc;
                } else {
                    this.form.description.items[index].subtotal = 0;
                }        
            },
        updateItem(index){
            const originalPrice = this.form.description.items[index].price + ''; // evitamos pass by reference
            this.form.description.items[index].price = this.$utils.getFormattedPrice(originalPrice) 
            this.$api.item_form.store(this.form.description.items[index])
                .then(res => {
                    
                   this.setEditableItem('');
                   this.editable_item_form_errors = {}; 
                   // Comprobamos que no sea null
                   if(this.form.description.items[index].price !== null){
                        this.form.description.items[index].price = this.$utils.completeWithZeros(originalPrice);
                   }
                    this.updateEditableItemSubtotal(index)
                   this.updateTotal();

                })
                .catch(error => {
                 
                    this.form.description.items[index].price = originalPrice;
                    if(error.response){
                        this.setItemFormErrorMessages(error.response.data.errors, index);
                    }
                });
        },
        setNumberWithCommas(value){
           return  value.toString().replace('.', ',');
        },

    },
    computed: {
        getStatusForOrder(){
            let older_data = JSON.parse(JSON.stringify(this.older_form_data));
            
            let new_data = JSON.parse(JSON.stringify(this.form));
            delete new_data.total;
            delete older_data.total;
            if(JSON.stringify(older_data) == JSON.stringify(new_data)){
                return  2
            } else {
                return 4
            }
        },
        totalWithCommas(){
            return parseFloat(this.form.total).toFixed(2).toString().replace('.', ',');
        },
        subtotalWithCommas(){
            return this.item_form.subtotal.toString().replace('.', ',');
        },
        editableItemSubtotalWithCommas(){
            return this.form.description.items[this.editableItem].subtotal;
        },
        isScheduledOrder: {
            get(){
                let type = typeof this.form.scheduled_order;
                if( type === 'object'){
                   this.shouldSchedule = 1; 
                    return 1;
                } else{
                    
                    return 0
                }
            },
            set(event){ 
                this.shouldSchedule = event;
            }
        },
        daysData: {
            get(){
                return this.form.scheduled_order.days;
            },
            set(event){
                this.form.days = event;
            }
        }
    }
    
}
</script>

<style lang='scss'>
    .fw-200{
        font-weight: 200;
    }
    .btn-circle.btn-xl {
    width: 70px;
    height: 70px;
    padding: 10px 16px;
    border-radius: 35px;
    font-size: 24px;
    line-height: 1.33;
}
.item-form-button{
    @media screen {
        margin-top: 1.75rem;
    }
}

.btn-circle {
    width: 30px;
    height: 30px;
    padding: 6px 0px;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
}

.item{
    padding-top: 1rem;
    padding-bottom: 1rem;
    &:nth-child(odd){
        background-color: white;
    }
}

@media screen and (max-width: 480px) {
    .buttons{
        width: 100%;
    }
}
@media screen and (min-width: 481px) and (max-width: 766px){
    .buttons{
        width: 50%;
    }
}
@media screen and (min-width: 767px) and (max-width: 1610px) {
    .buttons-container{
      flex: 0 0 100%;
      max-width: 100%;  
    }
}

.editable-item-input{
    @media screen and (max-width: 667px){
        padding-left: 8px;
        padding-right: 8px;
    }
    .input-group-prepend{
        @media screen and (max-width: 667px){
            display: none;
        }
    }
}

.item-list{
    padding: 0;
    max-width: 100%;
    
    padding-left: 15px;
    padding-right: 15px;
    @media screen and (max-width: 768px){
        overflow: hidden;
    }
}

</style>